import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import Link from 'components/Link';
import BackButton from 'components/BackButton';

interface HeaderNavigationProps {
  baseCrumb: {
    to: string;
    label: string;
  };
  crumbs: { to?: string; label: string }[];
}

function HeaderNavigation({ baseCrumb, crumbs }: HeaderNavigationProps) {
  return (
    <Box mb={8}>
      <BackButton backPath={baseCrumb.to} />

      <Breadcrumb fontSize="17px">
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to={baseCrumb.to} fontWeight={600}>
            {baseCrumb.label}
          </BreadcrumbLink>
        </BreadcrumbItem>

        {crumbs.map((crumb, index) => (
          <BreadcrumbItem key={`breadcrumbs-nav_${crumb.label}`} isCurrentPage={index === crumbs.length - 1}>
            <BreadcrumbLink>{crumb.label}</BreadcrumbLink>
          </BreadcrumbItem>
        ))}
      </Breadcrumb>
    </Box>
  );
}

export default HeaderNavigation;
